import { useDispatch } from 'react-redux';
import useToast from 'components/hooks/useToast';
import { updateProject } from 'state/callers';
import useProjectByTeamId from 'state/selectors/hooks/useProjectByTeamId';
import useTeamById from 'state/selectors/hooks/useTeamById';

const useGitTeamSettings = ({ teamId }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const team = useTeamById(teamId);
  const teamProject = useProjectByTeamId(teamId);
  const gitFilters = teamProject?.git_filter || {};

  const reposIds = gitFilters.repository_ids || [];
  const servicesIds = gitFilters.service_ids || [];

  const onSave = async ({ repositoriesIds, servicesIds }) => {
    try {
      await dispatch(
        updateProject(teamProject.id, {
          git_filter: {
            repository_ids: repositoriesIds,
            service_ids: servicesIds
          }
        })
      );
      toast({
        variant: 'success',
        message: 'Team git scope successfully saved',
        autoHideDuration: 3000
      });
    } catch (e) {
      toast({
        variant: 'error',
        message: 'Failed to save team git scope',
        autoHideDuration: 3000
      });
    }
  };

  return {
    team,
    teamProject,
    reposIds,
    servicesIds,
    onSave
  };
};

export default useGitTeamSettings;
